import { OrderType } from '@vista-digital/ocapi-types/v1';
export const getPaymentMethodsQueryForOrder = (order) => {
    switch (order.type) {
        case OrderType.Standard:
            return { orderType: OrderType.Standard, siteId: order.siteId };
        default:
            return { orderType: order.type };
    }
};
